import { gameConfig } from '../../../core/configs';

import {
  wheelDarkResource,
  wheelLightResource, wheelResourceNames,
} from '../../../core/gameConstants';

import { BaseWheelDrawer } from './BaseWheelDrawer';
import { GAME_SCENE_STATE } from '../../../stateManagment/gameState';
import { GAME_SCENE } from '../../../core/constats';
import { spinResponseHelper } from '../../../services/helperService/SpinResponseHelper';
import { bonusSpinResponseHelper } from '../../../services/helperService/BonusSpinResponseHelper';
import { animationDrawer } from '../../../core/AnimationDrawer';
import { crystalPerTypeHelper } from '../../../services/helperService/CrystalPerTypeHelper';

export class WheelDesktopDrawer extends BaseWheelDrawer {
  constructor() {
    super();
    this.loader = this.createLoader();
  }

  setupContainer() {
    this.setPosition(this.container, gameConfig.wheelPosition);
  }

  setWheel({ dark = false, crystals } = {}) {
    const radius = 300;
    const scale = radius / 252;

    const { circle } = this.getWheel({
      x: 0,
      y: 0,
      crystalCount: 64,
      radius,
      imageSize: { w: 40, h: 40 },
      imgPosition: { x: -7.5 },
      crystals,
      imageScale: .25,
      scale: dark ? 0 : scale,
    });


    this.winContainer.children = [];
    const goldenElementTexture = this.getGoldenElementTexture({ scale });
    const goldenRingTexture = this.getGoldenRingTexture({ scale });
    const wheelLight = this.getWheelLight({ scale });
    const wheelTexture = this.getWheelTexture({ scale }, dark);

    this.setPosition(wheelTexture, this.config.imagePosition);
    this.setPosition(goldenElementTexture, this.config.imagePosition);
    this.setPosition(goldenRingTexture, this.config.imagePosition);

    this.container.addChild(
      wheelTexture,
      this.winContainer,
      wheelLight,
      goldenRingTexture,
      this.wheelContainer,
      goldenElementTexture,
    );
    if (dark) {
      this.winContainer.addChild(this.getPressToContinue());
    } else {
      this.winContainer.addChild(this.getGoodLuck());
    }
    this.circle = circle;
  }

  rotate(resolve) {
    const helper = GAME_SCENE_STATE.getValue() === GAME_SCENE.MAIN ? spinResponseHelper : bonusSpinResponseHelper;
    super.rotateCircle(this.circle, resolve, helper);
  }

  screenTransaction() {
    this.winContainer.children = [];
    const texture = this.createSpine(this.resources[wheelResourceNames.wheelScreenTransaction]);
    texture.state.setAnimation(0, 'animation', false);
    this.container.addChild(texture);
    animationDrawer.shake(this.container, .1, gameConfig.wheelPosition);
  }

  resetWheelCrystals() {
    this.container.children = [];
    this.setWheel({ dark: GAME_SCENE_STATE.getValue() === GAME_SCENE.BONUS, crystals: crystalPerTypeHelper.crystals });
  }

  onLoad() {
    return this.loadResource([
      ...wheelDarkResource,
      ...wheelLightResource,
    ]);
  }

  async executeMainScene() {
    await this.loadResource([...wheelLightResource]);
    this.setupContainer();
    this.setWheel();
  }

  async executeBonusScene() {
    await this.loadResource([...wheelDarkResource]);
    this.setupContainer();
    this.setWheel({ dark: true });
  }
}
